const N = "blakfy_a11y_prefs", v = "blakfy_a11y_prefs", _e = 365, h = "1.0.0", $ = {
  READY: "blakfy:a11y:ready",
  CHANGE: "blakfy:a11y:change",
  OPEN: "blakfy:a11y:open",
  CLOSE: "blakfy:a11y:close"
}, o = {
  fontScale: 100,
  contrast: "normal",
  focusRing: !1,
  linkUnderline: !1,
  motion: "auto",
  dyslexiaFont: !1,
  readingMode: !1,
  lineHeight: "normal",
  letterSpacing: "normal",
  textAlign: "default",
  readingWidth: "default",
  highlightHeadings: !1,
  saturation: "normal",
  cursorSize: "default",
  hideImages: !1,
  readAloud: !1,
  readingMask: !1,
  magnifier: !1,
  stopAutoplay: !1
}, G = ["tr", "en", "de", "fr", "es", "it", "ar", "he", "ru"], Re = ["ar", "he"], Le = {
  INITIALIZED: "INITIALIZED",
  OPENDYSLEXIC_CDN_MISSING: "OPENDYSLEXIC_CDN_MISSING",
  STORAGE_MIGRATED: "STORAGE_MIGRATED",
  STORAGE_PARSE_ERROR: "STORAGE_PARSE_ERROR",
  SSR_HYDRATION_MISMATCH: "SSR_HYDRATION_MISMATCH",
  HOST_CSS_IMPORTANT_CONFLICT: "HOST_CSS_IMPORTANT_CONFLICT",
  LOCALE_FETCH_FAILED: "LOCALE_FETCH_FAILED",
  CDN_VERSION_MISMATCH: "CDN_VERSION_MISMATCH",
  OS_PREFERS_REDUCED_MOTION: "OS_PREFERS_REDUCED_MOTION",
  OS_PREFERS_CONTRAST_MORE: "OS_PREFERS_CONTRAST_MORE",
  OS_PREFERS_COLOR_SCHEME_DARK: "OS_PREFERS_COLOR_SCHEME_DARK",
  OS_PREFERS_REDUCED_TRANSPARENCY: "OS_PREFERS_REDUCED_TRANSPARENCY",
  OS_PREFERS_REDUCED_DATA: "OS_PREFERS_REDUCED_DATA",
  INVALID_PREF_VALUE: "INVALID_PREF_VALUE",
  SANDBOXED_IFRAME: "SANDBOXED_IFRAME",
  STORAGE_UNAVAILABLE: "STORAGE_UNAVAILABLE"
}, O = "blakfy-a11y-host", I = "html p, html li, html dd, html dt, html span, html div, html h1, html h2, html h3, html h4, html h5, html h6, html a, html label, html td, html th";
function D(e, t) {
  const n = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M6 2L6 26L12 20L16 28L19 27L15 19L22 19Z" fill="${e}" stroke="${t}" stroke-width="1.5" stroke-linejoin="round"/></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(n)}") 6 2`;
}
function V(e) {
  const t = [];
  if (e.fontScale !== 100 && t.push(`html { font-size: ${e.fontScale}% !important; }`), e.contrast === "high" && t.push(
    "html body, html body * { background-color: #000000 !important; color: #ffffff !important; border-color: #333333 !important; }",
    "html body a, html body a * { color: #ffff00 !important; }",
    "html body img { filter: invert(1) hue-rotate(180deg) !important; }"
  ), e.focusRing && t.push(
    "html *:focus, html *:focus-visible { outline: 4px solid #2563eb !important; outline-offset: 2px !important; }"
  ), e.linkUnderline && t.push("html a { text-decoration: underline !important; }"), e.motion === "reduce" && t.push(
    "html *, html *::before, html *::after { animation-duration: 0.001ms !important; animation-iteration-count: 1 !important; transition-duration: 0.001ms !important; scroll-behavior: auto !important; }"
  ), e.dyslexiaFont && t.push(
    "html * { font-family: 'OpenDyslexic', OpenDyslexic, Arial, sans-serif !important; }"
  ), e.readingMode && t.push(
    'html aside, html [role="complementary"] { display: none !important; }',
    'html [class*="sidebar"], html [id*="sidebar"] { display: none !important; }',
    'html [class*="banner"]:not(main *) { display: none !important; }'
  ), e.lineHeight === "medium" ? t.push(`${I} { line-height: 1.8 !important; }`) : e.lineHeight === "large" && t.push(`${I} { line-height: 2.4 !important; }`), e.letterSpacing === "medium" ? t.push("html * { letter-spacing: 0.08em !important; }") : e.letterSpacing === "large" && t.push("html * { letter-spacing: 0.16em !important; }"), e.textAlign !== "default" && t.push(
    `html p, html li, html h1, html h2, html h3, html h4, html h5, html h6 { text-align: ${e.textAlign} !important; }`
  ), e.readingWidth === "narrow" ? t.push("html p, html li, html blockquote { max-width: 80ch !important; }") : e.readingWidth === "narrower" && t.push("html p, html li, html blockquote { max-width: 60ch !important; }"), e.highlightHeadings && t.push(
    "html h1, html h2, html h3, html h4, html h5, html h6 { outline: 3px solid #2563eb !important; outline-offset: 3px !important; }"
  ), e.saturation === "none" ? (t.push("html { filter: grayscale(100%) !important; }"), t.push("blakfy-a11y-root { filter: none !important; }")) : e.saturation === "high" ? (t.push("html { filter: saturate(2) !important; }"), t.push("blakfy-a11y-root { filter: none !important; }")) : e.saturation === "low" && (t.push("html { filter: saturate(0.3) !important; }"), t.push("blakfy-a11y-root { filter: none !important; }")), e.cursorSize === "large-dark") {
    const n = D("black", "white");
    t.push(`html *, html *::before, html *::after { cursor: ${n}, default !important; }`);
  } else if (e.cursorSize === "large-light") {
    const n = D("white", "black");
    t.push(`html *, html *::before, html *::after { cursor: ${n}, default !important; }`);
  }
  return e.hideImages && t.push(
    'html img, html picture, html [role="img"]:not(svg):not([aria-label*="accessibility"]) { opacity: 0 !important; }',
    "html video { visibility: hidden !important; }"
  ), t.join(`
`);
}
function z(e) {
  if (typeof document > "u") return;
  let t = document.getElementById(O);
  t || (t = document.createElement("style"), t.id = O, t.setAttribute("data-blakfy", ""), (document.head || document.documentElement).appendChild(t)), t.textContent = V(e);
}
function W(e) {
  if (typeof document > "u") return;
  const t = document.documentElement;
  t && (t.setAttribute("data-a11y-fontscale", String(e.fontScale)), t.setAttribute("data-a11y-contrast", e.contrast), t.setAttribute("data-a11y-focus", e.focusRing ? "enhanced" : "default"), t.setAttribute("data-a11y-links", e.linkUnderline ? "underline" : "default"), t.setAttribute("data-a11y-motion", e.motion), t.setAttribute("data-a11y-dyslexia", String(e.dyslexiaFont)), t.setAttribute("data-a11y-reading", String(e.readingMode)), t.setAttribute("data-a11y-lineheight", e.lineHeight), t.setAttribute("data-a11y-letterspacing", e.letterSpacing), t.setAttribute("data-a11y-textalign", e.textAlign), t.setAttribute("data-a11y-readingwidth", e.readingWidth), t.setAttribute("data-a11y-headings", String(e.highlightHeadings)), t.setAttribute("data-a11y-saturation", e.saturation), t.setAttribute("data-a11y-cursor", e.cursorSize), t.setAttribute("data-a11y-hideimages", String(e.hideImages)), t.setAttribute("data-a11y-readaloud", String(e.readAloud)), t.setAttribute("data-a11y-readingmask", String(e.readingMask)), t.setAttribute("data-a11y-magnifier", String(e.magnifier)), t.setAttribute("data-a11y-stopautoplay", String(e.stopAutoplay)), z(e), j(e.readAloud), Y(e.stopAutoplay));
}
let p = null;
function E(e) {
  e.querySelectorAll("video[autoplay], audio[autoplay]").forEach((n) => {
    n.paused || n.pause(), n.removeAttribute("autoplay");
  });
}
function Y(e) {
  if (!(typeof document > "u")) {
    if (!e) {
      p?.disconnect(), p = null;
      return;
    }
    E(document), !p && (p = new MutationObserver((t) => {
      for (const n of t)
        n.addedNodes.forEach((r) => {
          if (r.nodeType !== 1) return;
          const i = r;
          i.matches?.("video[autoplay], audio[autoplay]") ? E(i.parentNode ?? document) : E(i);
        });
    }), p.observe(document.body, { childList: !0, subtree: !0 }));
  }
}
const C = "__blakfyReadAloudBound", w = { current: !1 };
function j(e) {
  if (typeof document > "u" || typeof window > "u" || !("speechSynthesis" in window)) return;
  const t = document;
  t[C] || (document.addEventListener("click", (n) => {
    if (!w.current) return;
    const r = n.target;
    if (!r || r.closest("blakfy-a11y-root")) return;
    const i = r.innerText?.trim();
    if (!i) return;
    window.speechSynthesis.cancel();
    const a = new SpeechSynthesisUtterance(i);
    a.lang = document.documentElement.lang || "en", window.speechSynthesis.speak(a);
  }), t[C] = !0), !e && w.current && "speechSynthesis" in window && window.speechSynthesis.cancel(), w.current = e;
}
function x() {
  if (typeof window > "u" || typeof window.matchMedia != "function")
    return {
      reducedMotion: !1,
      contrast: "normal",
      colorScheme: "no-preference",
      reducedTransparency: !1,
      reducedData: !1
    };
  let e = !1, t = "normal", n = "no-preference", r = !1, i = !1;
  try {
    e = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch {
  }
  try {
    window.matchMedia("(prefers-contrast: more)").matches ? t = "more" : window.matchMedia("(prefers-contrast: less)").matches && (t = "less");
  } catch {
  }
  try {
    window.matchMedia("(prefers-color-scheme: dark)").matches ? n = "dark" : window.matchMedia("(prefers-color-scheme: light)").matches && (n = "light");
  } catch {
  }
  try {
    r = window.matchMedia("(prefers-reduced-transparency: reduce)").matches;
  } catch {
  }
  try {
    i = window.matchMedia("(prefers-reduced-data: reduce)").matches;
  } catch {
  }
  return { reducedMotion: e, contrast: t, colorScheme: n, reducedTransparency: r, reducedData: i };
}
function ke() {
  if (typeof document > "u") return !1;
  const e = document.styleSheets;
  if (!e) return !1;
  for (let t = 0; t < e.length; t++) {
    const n = e[t];
    if (!n) continue;
    let r;
    try {
      r = n.cssRules ?? void 0;
    } catch {
      continue;
    }
    if (r)
      for (let i = 0; i < r.length; i++) {
        const a = r[i];
        if (!a || a.type !== 1) continue;
        const c = a, A = c.selectorText ?? "";
        if (!B(A)) continue;
        const f = c.style;
        if (f && (f.getPropertyPriority("color") === "important" || f.getPropertyPriority("background-color") === "important" || f.getPropertyPriority("background") === "important"))
          return !0;
      }
  }
  return !1;
}
function B(e) {
  const t = e.toLowerCase();
  return /(^|[\s,>+~])(body|a)([\s,:.#[>+~]|$)/.test(t);
}
function Oe(e) {
  if (typeof window > "u" || typeof window.matchMedia != "function")
    return () => {
    };
  const t = [
    "(prefers-reduced-motion: reduce)",
    "(prefers-contrast: more)",
    "(prefers-contrast: less)",
    "(prefers-color-scheme: dark)",
    "(prefers-color-scheme: light)"
  ], n = [], r = () => {
    e(x());
  };
  for (const i of t)
    try {
      const a = window.matchMedia(i);
      typeof a.addEventListener == "function" ? a.addEventListener("change", r) : typeof a.addListener == "function" && a.addListener(r), n.push(a);
    } catch {
    }
  return () => {
    for (const i of n)
      try {
        typeof i.removeEventListener == "function" ? i.removeEventListener("change", r) : typeof i.removeListener == "function" && i.removeListener(
          r
        );
      } catch {
      }
  };
}
const b = "2.0.0-alpha.11", T = 50, q = 10, s = {
  issues: [],
  startTime: typeof performance < "u" ? performance.now() : Date.now(),
  devPipeUrl: null,
  devPipeLastSent: []
};
function P() {
  try {
    if (typeof process < "u" && typeof process.env < "u" && process.env.NODE_ENV && process.env.NODE_ENV !== "production")
      return "verbose";
  } catch {
  }
  if (typeof window > "u" || typeof document > "u")
    return "silent";
  try {
    if (new URLSearchParams(window.location.search).get("a11y-debug") === "1") return "verbose";
  } catch {
  }
  try {
    const e = document.currentScript;
    if (e && e.dataset && e.dataset.debug === "true" || document.querySelector('script[data-debug="true"]')) return "verbose";
  } catch {
  }
  try {
    const e = window;
    if (e.__BLAKFY_A11Y__ && e.__BLAKFY_A11Y__.debug === !0) return "verbose";
  } catch {
  }
  return "silent";
}
function K(e) {
  return e === "info" ? "✓" : e === "warn" ? "⚠" : "✗";
}
function M(e, t) {
  if (typeof console > "u") return;
  const n = `[blakfy-a11y v${b}] ${K(e)} ${t}`;
  e === "error" && typeof console.error == "function" ? console.error(n) : e === "warn" && typeof console.warn == "function" ? console.warn(n) : typeof console.info == "function" ? console.info(n) : typeof console.log == "function" && console.log(n);
}
function F(e, t, n) {
  const r = s.devPipeUrl;
  if (!r || P() !== "verbose" || typeof fetch != "function") return;
  const i = Date.now();
  if (s.devPipeLastSent = s.devPipeLastSent.filter((a) => i - a < 1e3), !(s.devPipeLastSent.length >= q)) {
    s.devPipeLastSent.push(i);
    try {
      const a = JSON.stringify({ level: e, code: t, msg: n, timestamp: new Date(i).toISOString() });
      fetch(r, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: a,
        keepalive: !0
      }).catch(() => {
      });
    } catch {
    }
  }
}
function d(e, t, n, r) {
  const i = P();
  if (e === "info") {
    i === "verbose" && (M("info", n), F("info", t, n));
    return;
  }
  M(e, n);
  const a = {
    level: e,
    code: t,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    msg: n,
    ...r ? { extra: r } : {}
  };
  s.issues.push(a), s.issues.length > T && s.issues.splice(0, s.issues.length - T), F(e, t, n);
}
function Ie() {
  return s.issues.slice();
}
function De(e) {
  s.devPipeUrl = e;
}
function Ce() {
  s.issues = [], s.startTime = typeof performance < "u" ? performance.now() : Date.now(), s.devPipeUrl = null, s.devPipeLastSent = [];
}
function Te(e) {
  const t = x();
  return {
    version: b,
    locale: e.config.locale,
    theme: e.config.theme,
    storage: {
      version: e.storage.version,
      migratedFrom: e.storage.migratedFrom,
      keysFound: [...e.storage.keysFound]
    },
    osPreferences: {
      reducedMotion: t.reducedMotion,
      contrast: t.contrast,
      colorScheme: t.colorScheme,
      reducedTransparency: t.reducedTransparency,
      reducedData: t.reducedData
    },
    performance: {
      mountTimeMs: e.performance.mountTimeMs,
      bundleSizeGz: e.performance.bundleSizeGz,
      timeToFirstClick: e.performance.timeToFirstClick
    },
    issues: s.issues.map((n) => ({
      level: n.level,
      code: n.code,
      timestamp: n.timestamp,
      msg: n.msg
    })),
    config: { ...e.config },
    timestamp: (/* @__PURE__ */ new Date()).toISOString()
  };
}
function Me() {
  return b;
}
function u(e, t, n) {
  t !== void 0 && d(
    "warn",
    "INVALID_PREF_VALUE",
    `Invalid ${e} value received: ${JSON.stringify(t)} — falling back to '${String(n)}'.`,
    { field: e, received: t }
  );
}
const S = {
  locale: "en",
  theme: "light",
  position: "bottom-left",
  font: "",
  debug: !1,
  iconStyle: "access",
  keyboardShortcut: !0
};
function _(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
function J(e) {
  return e === 100 || e === 110 || e === 125 ? e : (u("fontScale", e, o.fontScale), o.fontScale);
}
function X(e) {
  return e === "normal" || e === "high" ? e : (u("contrast", e, o.contrast), o.contrast);
}
function l(e, t) {
  return typeof e == "boolean" ? e : t;
}
function Z(e) {
  return e === "auto" || e === "reduce" ? e : (u("motion", e, o.motion), o.motion);
}
function Q(e) {
  return e === "normal" || e === "medium" || e === "large" ? e : (u("lineHeight", e, o.lineHeight), o.lineHeight);
}
function ee(e) {
  return e === "normal" || e === "medium" || e === "large" ? e : (u("letterSpacing", e, o.letterSpacing), o.letterSpacing);
}
function te(e) {
  return e === "default" || e === "left" || e === "center" || e === "right" ? e : (u("textAlign", e, o.textAlign), o.textAlign);
}
function ne(e) {
  return e === "default" || e === "narrow" || e === "narrower" ? e : (u("readingWidth", e, o.readingWidth), o.readingWidth);
}
function ie(e) {
  return e === "normal" || e === "high" || e === "low" || e === "none" ? e : (u("saturation", e, o.saturation), o.saturation);
}
function re(e) {
  return e === "default" || e === "large-dark" || e === "large-light" ? e : (u("cursorSize", e, o.cursorSize), o.cursorSize);
}
function oe(e) {
  return typeof e == "string" && G.includes(e) ? e : "en";
}
function ae(e) {
  return e === "light" || e === "dark" || e === "auto" ? e : S.theme;
}
function se(e) {
  return e === "bottom-left" || e === "bottom-right" || e === "top-left" || e === "top-right" ? e : "bottom-left";
}
function y(e, t) {
  return typeof e == "string" ? e : t;
}
function le(e) {
  return e === "walking" || e === "access" || e === "eye" ? e : S.iconStyle;
}
function H(e) {
  return _(e) ? {
    fontScale: J(e.fontScale),
    contrast: X(e.contrast),
    focusRing: l(e.focusRing, o.focusRing),
    linkUnderline: l(e.linkUnderline, o.linkUnderline),
    motion: Z(e.motion),
    dyslexiaFont: l(e.dyslexiaFont, o.dyslexiaFont),
    readingMode: l(e.readingMode, o.readingMode),
    lineHeight: Q(e.lineHeight),
    letterSpacing: ee(e.letterSpacing),
    textAlign: te(e.textAlign),
    readingWidth: ne(e.readingWidth),
    highlightHeadings: l(e.highlightHeadings, o.highlightHeadings),
    saturation: ie(e.saturation),
    cursorSize: re(e.cursorSize),
    hideImages: l(e.hideImages, o.hideImages),
    readAloud: l(e.readAloud, o.readAloud),
    readingMask: l(e.readingMask, o.readingMask),
    magnifier: l(e.magnifier, o.magnifier),
    stopAutoplay: l(e.stopAutoplay, o.stopAutoplay)
  } : { ...o };
}
function ce(e) {
  if (!_(e)) return null;
  const t = H(e.prefs), n = y(e.version, h), r = y(e.timestamp, (/* @__PURE__ */ new Date()).toISOString()), i = y(e.locale, "en");
  return { prefs: t, version: n, timestamp: r, locale: i };
}
function Fe(e) {
  return _(e) ? {
    locale: oe(e.locale),
    theme: ae(e.theme),
    position: se(e.position),
    font: y(e.font, ""),
    debug: l(e.debug, !1),
    iconStyle: le(e.iconStyle),
    keyboardShortcut: l(e.keyboardShortcut, S.keyboardShortcut)
  } : { ...S };
}
function de(e, t) {
  if (!(typeof window > "u"))
    try {
      const n = new CustomEvent(e, { detail: t });
      window.dispatchEvent(n);
    } catch {
    }
}
function Ne(e, t) {
  if (typeof window > "u")
    return () => {
    };
  const n = (r) => {
    t(r.detail);
  };
  return window.addEventListener(e, n), () => {
    typeof window > "u" || window.removeEventListener(e, n);
  };
}
function R() {
  return typeof window < "u";
}
function U() {
  return typeof document < "u";
}
function ue(e, t, n) {
  if (!U()) return;
  const r = /* @__PURE__ */ new Date();
  r.setTime(r.getTime() + n * 864e5);
  const i = R() && window.location && window.location.protocol === "https:", a = [
    `${e}=${encodeURIComponent(t)}`,
    `expires=${r.toUTCString()}`,
    "path=/",
    "SameSite=Lax"
  ];
  i && a.push("Secure");
  try {
    document.cookie = a.join(";");
  } catch {
    d(
      "warn",
      "STORAGE_UNAVAILABLE",
      "Cookie write failed — preferences may not persist across reloads.",
      { storage: "cookie", op: "write" }
    );
  }
}
function fe(e) {
  if (!U()) return null;
  let t = "";
  try {
    t = document.cookie || "";
  } catch {
    return null;
  }
  const n = t.match(new RegExp(`(^| )${e}=([^;]+)`));
  if (!n || typeof n[2] != "string") return null;
  try {
    return decodeURIComponent(n[2]);
  } catch {
    return null;
  }
}
function me(e) {
  if (!R()) return null;
  try {
    return window.localStorage.getItem(e);
  } catch {
    return null;
  }
}
function he(e, t) {
  if (R())
    try {
      window.localStorage.setItem(e, t);
    } catch {
      d(
        "warn",
        "STORAGE_UNAVAILABLE",
        "localStorage write failed (quota or private mode) — preferences may not persist across reloads.",
        { storage: "localStorage", op: "write" }
      );
    }
}
function ge(e) {
  if (e == null) return null;
  try {
    return JSON.parse(e);
  } catch {
    return null;
  }
}
function pe(e) {
  return e.version === h ? { record: e, migrated: !1, migratedFrom: null } : { record: {
    prefs: { ...o, ...e.prefs },
    version: h,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    locale: e.locale || "en"
  }, migrated: !0, migratedFrom: e.version };
}
function L() {
  const e = [], t = me(N);
  t != null && e.push("localStorage");
  const n = fe(v);
  n != null && e.push("cookie");
  let r = null, i = null;
  if (t != null ? (r = t, i = "localStorage") : n != null && (r = n, i = "cookie"), r == null)
    return { source: null, record: null, migrated: !1, migratedFrom: null, keysFound: e };
  const a = ge(r);
  if (a == null)
    return d("error", "STORAGE_PARSE_ERROR", `Failed to parse stored preferences from ${i}`), { source: i, record: null, migrated: !1, migratedFrom: null, keysFound: e };
  const c = ce(a);
  if (!c)
    return d(
      "error",
      "STORAGE_PARSE_ERROR",
      `Stored preferences in ${i} did not match schema`
    ), { source: i, record: null, migrated: !1, migratedFrom: null, keysFound: e };
  const { record: A, migrated: f, migratedFrom: k } = pe(c);
  return f && d(
    "info",
    "STORAGE_MIGRATED",
    `Storage migrated: ${k ?? "unknown"} → ${h}`
  ), { source: i, record: A, migrated: f, migratedFrom: k, keysFound: e };
}
function ye(e) {
  const t = JSON.stringify(e);
  he(N, t), ue(v, t, 365);
}
function Se() {
  const e = L();
  return e.record ? { ...o, ...e.record.prefs } : { ...o };
}
function ve() {
  return L().record;
}
function Ae(e, t = "en") {
  const n = Se(), r = H({ ...n, ...e }), i = {
    prefs: r,
    version: h,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    locale: t
  };
  return ye(i), W(r), de($.CHANGE, i), i;
}
function xe(e = "en") {
  return Ae({ ...o }, e);
}
function Pe() {
  const e = L();
  return {
    version: e.record?.version ?? h,
    migratedFrom: e.migratedFrom,
    keysFound: e.keysFound
  };
}
const Ee = {
  label: "Accessibility preferences"
}, we = {
  title: "Accessibility Preferences",
  description: "Adjust your viewing preferences.",
  reset: "Reset",
  close: "Close",
  disclaimer: "This panel provides personal preference controls; structural accessibility is built into the site itself.",
  theme: {
    label: "Display Theme",
    auto: "Auto",
    light: "Light",
    dark: "Dark"
  },
  branding: "Powered by Blakfy Studio",
  sections: {
    profiles: "Accessibility Profiles",
    text: "Text",
    vision: "Vision",
    navigation: "Navigation",
    motion: "Motion & Reading"
  },
  profiles: {
    epilepsy: {
      name: "Epilepsy Safe",
      description: "Reduces animations and desaturates colors"
    },
    vision: {
      name: "Visual Impairment",
      description: "High contrast and enlarged text"
    },
    cognitive: {
      name: "Cognitive",
      description: "Reduces distractions, aids readability"
    },
    adhd: {
      name: "ADHD Friendly",
      description: "Hides images, stops motion"
    },
    blindness: {
      name: "Screen Reader",
      description: "Optimised for assistive technology"
    }
  },
  preferences: {
    fontScale: {
      title: "Font Size",
      description: "Scales all text proportionally across the page. Ideal for small screens or users with low vision; changes apply instantly everywhere.",
      values: {
        100: "Normal",
        110: "Large",
        125: "Extra Large"
      }
    },
    lineHeight: {
      title: "Line Height",
      description: "Increases vertical spacing between lines of text, improving readability for users with dyslexia or cognitive disabilities.",
      values: {
        normal: "Normal",
        medium: "Medium",
        large: "Large"
      }
    },
    letterSpacing: {
      title: "Letter Spacing",
      description: "Adds extra space between characters to reduce crowding and improve text clarity.",
      values: {
        normal: "Normal",
        medium: "Medium",
        large: "Large"
      }
    },
    textAlign: {
      title: "Text Alignment",
      description: "Changes the alignment of body text and headings across the page.",
      values: {
        default: "Default",
        left: "Left",
        center: "Center",
        right: "Right"
      }
    },
    highlightHeadings: {
      title: "Highlight Headings",
      description: "Adds a visible blue outline around all headings to make page structure easier to navigate."
    },
    contrast: {
      title: "High Contrast",
      description: "Applies a black background with high-visibility yellow links meeting the WCAG AAA 7:1 contrast ratio. Designed for users with visual impairments or colour blindness."
    },
    saturation: {
      title: "Color Saturation",
      description: "Adjusts color intensity. Use Grayscale to remove all color — useful for color blindness or reducing visual distraction.",
      values: {
        normal: "Normal",
        high: "High",
        low: "Low",
        none: "Grayscale"
      }
    },
    focusRing: {
      title: "Enhanced Focus Ring",
      description: "Displays a bold 4px blue outline around the focused element during keyboard navigation. Essential for users who cannot use or prefer not to use a mouse."
    },
    linkUnderline: {
      title: "Underline Links",
      description: "Adds underlines to all hyperlinks on the page. Helps users who cannot distinguish links from regular text by colour alone."
    },
    cursorSize: {
      title: "Cursor Size",
      description: "Enlarges the mouse cursor for better screen visibility. Choose dark or light to suit your background.",
      values: {
        default: "Default",
        largeDark: "Large Dark",
        largeLight: "Large Light"
      }
    },
    motion: {
      title: "Reduce Motion",
      description: "Disables page animations, transitions and scroll effects. Recommended for users with vestibular disorders, epilepsy or motion sensitivity."
    },
    dyslexiaFont: {
      title: "Dyslexia-Friendly Font",
      description: "Applies the OpenDyslexic typeface, adding extra weight to letter bottoms to reduce confusion between similar characters (b/d, p/q) and improve readability.",
      note: "Some readers find this helpful; research has not established universal benefit."
    },
    readingMode: {
      title: "Reading Mode",
      description: "Hides sidebars, banners and distracting side content so you can focus on the main text. Ideal for long articles or visually busy pages."
    },
    hideImages: {
      title: "Hide Images",
      description: "Hides all images on the page, reducing visual distraction. Useful for users sensitive to visual stimuli or on slow connections."
    },
    readAloud: {
      title: "Read Aloud",
      description: "Click any text on the page to have it read aloud using your browser's built-in text-to-speech."
    },
    readingMask: {
      title: "Reading Mask",
      description: "Dims the page except for a horizontal band that follows your cursor, helping you focus on one line of text at a time."
    },
    magnifier: {
      title: "Magnifier",
      description: "Shows a magnified lens that follows your cursor. Note: it may not perfectly magnify videos or other live content."
    },
    stopAutoplay: {
      title: "Stop Autoplay",
      description: "Stops videos and audio from playing automatically, per WCAG 2.2.2 (Pause, Stop, Hide). Embedded third-party players (e.g. YouTube) may not be affected."
    },
    readingWidth: {
      title: "Reading Width",
      description: "Limits the width of text blocks for easier line-tracking, per WCAG 1.4.8.",
      values: {
        default: "Default",
        narrow: "Narrow",
        narrower: "Narrower"
      }
    }
  }
}, m = {
  fab: Ee,
  panel: we
}, g = /* @__PURE__ */ new Map();
g.set("en", m);
function be(e) {
  if (!e || typeof e != "object") return !1;
  const t = e, n = t.fab, r = t.panel;
  return !(!n || typeof n.label != "string" || !r || typeof r.title != "string");
}
async function He(e, t) {
  const n = g.get(e);
  if (n) return n;
  if (typeof fetch != "function")
    return d("warn", "LOCALE_FETCH_FAILED", `fetch unavailable, using en fallback for ${e}`), m;
  const i = `${(t || "").replace(/\/$/, "")}/locales/${e}.json`;
  try {
    const a = await fetch(i);
    if (!a.ok)
      return d("warn", "LOCALE_FETCH_FAILED", `Locale fetch failed (${a.status}): ${i}`), m;
    const c = await a.json();
    return be(c) ? (g.set(e, c), c) : (d("warn", "LOCALE_FETCH_FAILED", `Locale ${e} payload missing required fields`), m);
  } catch (a) {
    const c = a instanceof Error ? a.message : String(a);
    return d("warn", "LOCALE_FETCH_FAILED", `Locale fetch threw for ${e}: ${c}`), m;
  }
}
function Ue(e) {
  return g.get(e) ?? null;
}
function $e() {
  return m;
}
function Ge() {
  g.clear(), g.set("en", m);
}
export {
  _e as COOKIE_DAYS,
  v as COOKIE_KEY,
  o as DEFAULT_PREFS,
  $ as EVENT_NAMES,
  Le as ISSUE_CODES,
  G as LOCALE_CODES,
  Re as RTL_LOCALES,
  N as STORAGE_KEY,
  h as STORAGE_VERSION,
  Pe as _inspectStorage,
  Ce as _resetDiagnostics,
  Ge as _resetLocaleCache,
  d as addIssue,
  Y as applyAutoplayControl,
  W as applyPreferences,
  j as applyReadAloud,
  ke as detectHostCSSConflicts,
  x as detectOSPreferences,
  de as emit,
  Ue as getCachedLocale,
  Te as getDiagnostics,
  $e as getEnglishLocale,
  Ie as getIssues,
  P as getMode,
  Se as getPreferences,
  ve as getPreferencesRecord,
  Me as getVersion,
  He as loadLocale,
  Ne as on,
  xe as resetPreferences,
  Fe as safeMergeOptions,
  H as safeMergePrefs,
  ce as safeParseRecord,
  De as setDevPipe,
  Ae as setPreferences,
  Oe as subscribeToOSChanges
};
//# sourceMappingURL=index.js.map
